import { makeStyles } from 'tss-react/mui';
import { theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the AwardItem component.
 */
const useAwardItemStyles = makeStyles()(() => ({
  icon: {
    height: theme.iconSize,
    width: 'auto',
    marginBottom: theme.margin.m,
  },
  awardItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0,
    padding: theme.padding.m,
    width: '150px',
    position: 'relative',
  },
  name: {
    textAlign: 'center',
    marginBottom: theme.margin.s,
  },
  count: {
    textAlign: 'center',
    color: theme.text.primary.light,
    fontWeight: theme.fontWeight.bold,
    boxShadow: theme.buttonShadow(theme.primary.light),
    padding: `${theme.padding.xs} ${theme.padding.s}`,
    borderRadius: theme.borderRadius.xs,
    border: `1px solid ${theme.primary.light}`,
  },
}));

export default useAwardItemStyles;
